import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import './breadcrumbs.scss'; // Maps all page codes to corresponding page titles

var pages = {
  '': '',
  // empty option needed in some cases
  '/': 'Sākumlapa',
  zinas: 'Ziņas' // TODO: dedicated pages for news/blogs/posts list

};
export var BreadcrumbsFactory = function BreadcrumbsFactory() {};

BreadcrumbsFactory.empty = function () {
  return {
    title: '',
    path: ''
  };
};

BreadcrumbsFactory.currentPage = function (title, path) {
  if (path === void 0) {
    path = '';
  }

  return {
    title: title,
    path: path
  };
};

var Breadcrumbs = function Breadcrumbs(_ref) {
  var pageKeys = _ref.pageKeys;
  if (pageKeys.length === 0) return null;
  var items = pageKeys.map(function (key) {
    if (typeof key === 'string') return {
      path: key,
      title: pages[key]
    };
    return key;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("nav", {
    className: "breadcrumb",
    "aria-label": "breadcrumbs"
  }, /*#__PURE__*/React.createElement("ul", null, items.map(function (item, i) {
    return /*#__PURE__*/React.createElement("li", {
      key: i,
      className: i === items.length - 1 ? 'is-active' : undefined
    }, item.path === null ? /*#__PURE__*/React.createElement("span", {
      "aria-current": i === items.length - 1 ? 'page' : undefined,
      className: "static-breadcrumb"
    }, item.title) : /*#__PURE__*/React.createElement(GatsbyLink, {
      to: item.path !== '' ? item.path : '/',
      key: item.path
    }, /*#__PURE__*/React.createElement("span", {
      "aria-current": i === items.length - 1 ? 'page' : undefined
    }, item.title)));
  }))));
};

export default Breadcrumbs;